const cityCharges = [
    {
      city: "Mumbai",
      charges: {
        RoadTax: "₹15,000",
        Insurance: "₹8,000",
        RegistrationFee: "₹2,500",
        OtherCharges: "₹1,500",
      },
    },
    {
      city: "Delhi",
      charges: {
        RoadTax: "₹12,000",
        Insurance: "₹7,500",
        RegistrationFee: "₹2,200",
        OtherCharges: "₹1,200",
      },
    },
    {
      city: "Bangalore",
      charges: {
        RoadTax: "₹18,000",
        Insurance: "₹9,000",
        RegistrationFee: "₹2,800",
        OtherCharges: "₹1,800",
      },
    },
    {
      city: "Chennai",
      charges: {
        RoadTax: "₹14,000",
        Insurance: "₹7,800",
        RegistrationFee: "₹2,300",
        OtherCharges: "₹1,400",
      },
    },
    {
      city: "Pune",
      charges: {
        RoadTax: "₹13,500",
        Insurance: "₹7,000",
        RegistrationFee: "₹2,400",
        OtherCharges: "₹1,300",
      },
    },
    {
      city: "Pimpri-Chinchwad",
      charges: {
        RoadTax: "₹13,000",
        Insurance: "₹6,800",
        RegistrationFee: "₹2,350",
        OtherCharges: "₹1,200",
      },
    },
  ];
  

export default cityCharges